import { TaskControllerApi, TaskReviewed } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface Params {
  taskReviewed: TaskReviewed;
  xTENANTID?: string;
}

export const useReviewTask = () =>
  useMutationWithLoading(async (params: Params) =>
    new TaskControllerApi(getConfigObject()).reviewTask(
      params.taskReviewed,
      params.xTENANTID
    )
  );
